import { cn } from '@/shared/lib/cn'

/**
 * Decorative background layers for hero and banner sections.
 *
 * Always absolutely positioned, always aria-hidden, never a content carrier —
 * the page must read identically with these removed. The patterns themselves
 * are the bg-grid / bg-dots / bg-glow utilities in styles/index.css, since
 * they are CSS gradients that no stock utility can express.
 */
export function Backdrop({
  variant = 'grid',
  className,
}: {
  variant?: 'grid' | 'dots' | 'grid-dark'
  className?: string
}) {
  return (
    <div
      aria-hidden="true"
      className={cn('pointer-events-none absolute inset-0 overflow-hidden', className)}
    >
      {variant === 'grid' && (
        <>
          <div className="bg-grid mask-fade-b absolute inset-0 opacity-60" />
          <div className="bg-glow absolute inset-x-0 -top-1/3 h-[150%]" />
        </>
      )}

      {variant === 'grid-dark' && (
        <>
          <div className="bg-grid mask-fade-b absolute inset-0 opacity-[0.07]" />
          <div className="bg-glow-dark absolute inset-x-0 -top-1/2 h-[200%]" />
        </>
      )}

      {variant === 'dots' && (
        <div className="bg-dots mask-fade-x absolute inset-0 opacity-70" />
      )}
    </div>
  )
}
